const microbiomeTableFields = Object.freeze({
  healthDiseaseAssociation:{
    "sortable": false,
    "label": ""
  },
  Phylum:{
    "sortable": true,
    "label": "Phylum"
  },
  TaxonomyRank:{
    "label": "Taxonomy Rank",
    "actionable": false,
    "sortable": true
  },
  Abundance:{
    "label": "Abundance",
    "sortable": true
  },
  Range:{
    "label": "Range",
    "sortable": false
  },
  Level:{
    "label": "Level",
    "sortable": true
  }
})

export {microbiomeTableFields}


//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/model/microbiomeProfile.js
// module id = HilR
// module chunks = 0